import { dispatchSendSocketMessage } from 'store/dispatcher'

export const submitChoice = ({ quesUuid, choiceUuid }) =>
    dispatchSendSocketMessage({
        action: 'answer',
        quiz_question: quesUuid,
        choice: choiceUuid,
    })
